import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../../components/ui/Modal";
import { Button } from "../../../../components/ui/Button";

/**
 * Confirmación de rotar o revocar. Las dos acciones cortan de inmediato al sistema
 * que usa la credencial, así que nunca se disparan con un solo clic.
 */
export default function ConfirmCredentialActionModal({
  action,
  credential,
  busy,
  errorMessage,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  const name = credential?.name ?? "";
  const isRevoke = action === "revoke";

  return (
    <Modal
      open={Boolean(action && credential)}
      onClose={busy ? undefined : onCancel}
      size="md"
      title={
        isRevoke
          ? t("¿Revocar {{name}}?", { name })
          : t("¿Rotar el secreto de {{name}}?", { name })
      }
      footer={
        <>
          <Button variant="outline" onClick={onCancel} disabled={busy}>
            {t("Cancelar")}
          </Button>
          <Button variant={isRevoke ? "danger" : "primary"} onClick={onConfirm} loading={busy}>
            {isRevoke ? t("Revocar") : t("Rotar secreto")}
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-fg-muted">
          {isRevoke
            ? t("La credencial deja de funcionar de inmediato y no se puede reactivar. Tu sistema ya no podrá crear pedidos con ella.")
            : t("Se genera un secreto nuevo y el actual deja de funcionar de inmediato. Tu sistema fallará hasta que cargues el nuevo.")}
        </p>
        {errorMessage && (
          <p className="text-sm text-status-error" role="alert">
            {errorMessage}
          </p>
        )}
      </div>
    </Modal>
  );
}
